import React from 'react';
import { FaInstagram } from 'react-icons/fa';
import { FiYoutube } from 'react-icons/fi';
import { TbBrandTiktok } from 'react-icons/tb';
import { useAppSelector } from 'hooks/useStore';
import './index.css';

function Footer() {
    const { organization } = useAppSelector(state => state.organization);

    return (
        <div className='footer'>
            {organization.alias !== 'alumnitutoring' && organization.alias !== 'honolulumathtutor' &&
                <p className='footer__copyright'>
                    {/* &copy; {new Date().getFullYear()}
                    &nbsp;WellEd Labs Corp.
                    &nbsp;All Rights Reserved */}
                    Powered by &copy; WellEd Labs Corp.
                </p>
            }
            <div className='footer__social'>
                {/* <a
                    href=''
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <FaFacebookF className='footer__socialIcon' />
                </a> */}
                {/* <a
                    href='https://www.instagram.com/thesatcrashcourse/'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <FaInstagram className='footer__socialIcon' />
                </a>
                <a
                    href='https://www.tiktok.com/@thesatcrashcourse'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <TbBrandTiktok className='footer__socialIcon' />
                </a>
                <a
                    href='https://www.youtube.com/@thesatcrashcourse/featured'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <FiYoutube className='footer__socialIcon' />
                </a> */}
            </div>
        </div>
    );
}

export default Footer;